import React from 'react';
// CSS
import '../assets/css/service-card.css';
// Icons
import Branding from '../assets/images/branding.png';
import RecordIcon from '../assets/icons/record.png';

export default function ServiceCard(props) {
  return (
    <div className="service_card">
      <div className="icon_bg select_n">
        <div className="icon bx_shadow_round">
          <img src={props.icon} />
        </div>
      </div>
      <div className="service_title">{props.title}</div>
      <p>{props.description}</p>
    </div>
  )
}
